import { render, staticRenderFns } from "./AvailabilityEditor.vue?vue&type=template&id=4481fa1a&scoped=true&"
import script from "./AvailabilityEditor.vue?vue&type=script&lang=ts&"
export * from "./AvailabilityEditor.vue?vue&type=script&lang=ts&"
import style0 from "./AvailabilityEditor.vue?vue&type=style&index=0&id=4481fa1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4481fa1a",
  null
  
)

export default component.exports